import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CustomerAddressState {
  bill: string;
  shipTo: string;
  cc: string;
}

const initialState: CustomerAddressState = {
  bill: '',
  shipTo: '',
  cc: '',
};

const customerAddressSlice = createSlice({
  name: 'customerAddress',
  initialState,
  reducers: {
    setBillTo(state, action: PayloadAction<string>) {
      state.bill = action.payload;
    },
    setShipTo(state, action: PayloadAction<string>) {
      state.shipTo = action.payload;
    },
    setCC(state, action: PayloadAction<string>) {
      state.cc = action.payload;
    },
  },
});

export const { setBillTo, setShipTo, setCC } = customerAddressSlice.actions;
export default customerAddressSlice.reducer;
